import { getAllSegments } from '@/player-config/src/utils/clipUtils';
import { Clip } from '@/player-config/src/types/clip-types';

/**
 * Returns the total duration in frames for the given clip.
 * Calculates the duration by finding the highest `toFrame` value across all segments
 * of the clip. This approach ensures the result is not rounded and considers all
 * segment end positions, not just the last one.
 *
 * @param {Clip} clip - The clip object containing segment information.
 * @returns {number} The maximum `toFrame` value (total duration) of the clip in frames.
 */

export const getClipTotalDurationInFrames = (clip: Clip) => {
  const allSegments = getAllSegments(clip);
  if (allSegments.length === 0) {
    return 0;
  }
  const totalDuration = Math.max(...allSegments.map(segment => segment.toFrame));
  return totalDuration;
};
